import { useEffect, useReducer, useRef } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import classes from "../Sigfox/SigfoxModalForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import { setWebeyeIntegration } from '../../../../../../Api Methods/Api';
import { Button } from 'primereact/button';

const WebeyeDetailsReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise
    return { value: '', isValid: false };
}

const WebeyeForm = ({ setShowVirtualSource, fetchVirtualSources, setShowSuccess }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }

    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [webeyeDetailsState, dispatchWebeyeDetailsState] = useReducer(WebeyeDetailsReducer, {
        value: '',
        isValid: null
    });

    const webeyeDetailsInputRef = useRef();
    const { isValid: webeyeDetailsIsValid } = webeyeDetailsState;

    const webeyeDetailsChangeHandler = (event) => {
        dispatchWebeyeDetailsState({ type: 'USER_INPUT', val: event.target.value });
    }

    const validateWebeyeDetailsHandler = () => {
        dispatchWebeyeDetailsState({ type: 'INPUT_BLUR' });
    }

    const HandelResetModal = () => {
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();

        const body = {
            "siteUUID": DeviceUUID,
            "webeyeAddress": webeyeDetailsState.value,
        }

        const responseData = await setWebeyeIntegration(apiData, body, dispatch)
        if (responseData && responseData.success) {
            HandleCloseModal();
            fetchVirtualSources();
            setShowSuccess(true);
        }
    };

    useEffect(() => {
        HandleShowModal();
    }, []);

    return (
        <Modal ref={ModalDialog} title={"Add Webeye Integration"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
            <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
                <ul className={classes["inputs-list"]}>
                    <li className={classes["input-container"]}>
                        <label className={classes.subTitle}>Webeye integration details</label>
                        <Input
                            className={classes.input}
                            placeholder={"Enter integration details"}
                            ref={webeyeDetailsInputRef}
                            id="WebeyeIntegrationDetails"
                            type={"text"}
                            isValid={webeyeDetailsState.isValid}
                            value={webeyeDetailsState.value}
                            onChange={webeyeDetailsChangeHandler}
                            onBlur={validateWebeyeDetailsHandler}
                        />
                    </li>
                </ul>
                <br />
                <Button icon="pi pi-save" type="submit" label="Save" severity='success' disabled={!webeyeDetailsIsValid} />
            </form>
        </Modal>
    )
}

export default WebeyeForm;
